// extracted by mini-css-extract-plugin
module.exports = {"options":"_32bRY08lzlqG-QYO1jbGpD","selectionItems":"_2dyUQXlodwv3TOnfqaq14t","title":"_2xbpUQYuXKvzxohCKxSXkl","selectionText":"wLgQ_0QSJ8GiUAlLPqF_M"};